<div style="display: flex; flex-direction: row; justify-content: space-between">
  <div
    class="rfq-create-form"
    style="
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      margin: 0px 0px 30px 5px !important;
    "
  >
    <div class="rfq-create-form-title">
      <!-- improved the buttons to align with figma -->
      <div
        style="
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          padding: 10px;
          justify-content: flex-end;
          background-color: white;
        "
      >
        <button
          mat-button
          color="primary"
          style="
            font-size: 18px;
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 24px;
            padding-bottom: 24px;
            background-color: #f99c30 !important;
          "
          (click)="submit(true)"
        >
          Save as Draft
        </button>
        <button
          mat-button
          color="primary"
          style="
            font-size: 18px;
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 24px;
            padding-bottom: 24px;
            background-color: #f99c30 !important;
          "
          (click)="submit(false)"
        >
          Submit
        </button>
        <!-- <button
          mat-button
          color="primary"
          style="
            font-size: 18px;
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 24px;
            padding-bottom: 24px;
            background-color: #f99c30 !important;
          "
          (click)="back()"
        >
          Back
        </button> -->
      </div>
      <!-- <div style="display: flex;justify-content: center;align-items:center;padding:0px 15px;">
          <button mat-button color="primary"
          style="margin:0px 10px;font-size:18px; padding-left: 30px; padding-right: 25px; padding-top: 24px; padding-bottom: 24px; background-color: #f99c30 !important;"
          
          (click)="submit(true)">Save as Draft</button>

          <button mat-button color="primary"
              style="margin:0px 10px;font-size:18px; padding-left: 25px; padding-right: 25px; padding-top: 24px; padding-bottom: 24px; background-color: #f99c30 !important;"
              
              (click)="submit(false)">Submit</button>

          <button mat-button color="primary"
              style="margin:0px 10px;font-size:18px; padding-left: 25px; padding-right: 25px; padding-top: 24px; padding-bottom: 24px; background-color: #f99c30 !important;"
              (click)="back()">Back</button>
      </div> -->
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 10px;
          margin-bottom: 5px;
        "
      >
        <div *ngIf="showDataForBuyer" id="createquotation">
          Create Quotation
        </div>
      </div>
    </div>

    <div
      class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4"
      style="width: 100%"
    >
      <mat-card class="p-0" style="margin: 0 0.5rem">
        <mat-card-content class="ship-fscoll hgt ship-pr-sec">
          <nav mat-tab-nav-bar class="tagGroup">
            <!-- <a
              mat-tab-link
              *ngFor="let tabItem of tabs; let idx = index"
              [class.active-link]="currentTab === tabItem.route"
              class="teb_icon"
              (click)="selectMatTabLink(tabItem)"
            >
              <span id="navstepstext">{{ tabItem.label }}</span>
            </a> -->
            <a
              mat-tab-link
              *ngFor="let tabItem of tabs; let idx = index"
              [class.active-link]="currentTab === tabItem.route"
              class="teb_icon"
              (click)="userRole !== 'Owner' && selectMatTabLink(tabItem)"
              [ngClass]="{ 'disabled-link': userRole === 'Owner' }"
            >
              <span id="navstepstext">{{ tabItem.label }}</span>
            </a>
          </nav>

          <div class="mat-tab-body-content pos-relative">
            <div
              class="quote-form-preview-container"
              style="display: flex; flex-direction: column; gap: 10px"
            >
              <!-- LINE ITEMS TAB -->
              <div
                class="quote-form-line-items-section"
                style="margin-top: 20px"
              >
                <!-- <h2 style="margin-bottom: 10px; font-weight: bolder">
                  Quote Form - Line Items
                </h2> -->
                <div>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <div>
                      <form [formGroup]="secondFormGroup">
                        <div
                          class="form-item-row"
                          style="
                            
                            margin-bottom: 0px;
                          "
                        >
                          <div
                            style="
                              display: flex;
                              flex-direction: column;
                              width: 100%;
                            "
                          >
                            <label>Quote Currency</label>
                            <input
                              *ngIf="headerData?.currencyId?.currencyCode"
                              type="text"
                              [value]="headerData.currencyId.currencyCode + ' - ' + (headerData.currencyId.currencyName || '')"
                              readonly
                              style="background-color: #f0f0f0; padding: 8px; border: 1px solid #ccc; border-radius: 4px; color: #333; cursor: not-allowed;"
                            />
                            <input
                              *ngIf="!headerData?.currencyId?.currencyCode"
                              type="text"
                              [value]="supplierCurrencyName || 'Loading...'"
                              readonly
                              style="background-color: #f9f9f9; padding: 8px; border: 1px solid #e0e0e0; border-radius: 4px; color: #bbb; cursor: not-allowed; font-size: 11px; font-style: italic;"
                            />
                          </div>
                          <!-- <small
                            *ngIf="
                              secondFormGroup ||
                              secondFormGroup['controls']['supplierCurrency'][
                                'dirty'
                              ] ||
                              secondFormGroup['controls']['supplierCurrency'][
                                'touched'
                              ]
                            "
                            class="form-error-msg"
                          >
                            <div
                              style="padding: 2px"
                              *ngIf="
                                secondFormGroup.controls[
                                  'supplierCurrency'
                                ].hasError('required')
                              "
                            >
                              *Currency should not be empty.
                            </div>
                          </small> -->
                        </div>
                      </form>
                    </div>

                    <div
                      style="
                        display: flex;
                        justify-content: flex-end;
                        padding-top: 28px;
                      "
                    >
                      <div class="wrap-description-toggle">
                        <mat-slide-toggle
                          (change)="toggleWrapDescription($event)"
                          >Wrap Description</mat-slide-toggle
                        >
                      </div>
                      <div class="dropdown-container">
                        <button
                          mat-fab
                          class="green-button"
                          [matMenuTriggerFor]="columnsMenu"
                          matTooltip="Show more columns"
                        >
                          <mat-icon>add</mat-icon>
                        </button>
                        <mat-menu #columnsMenu="matMenu">
                          <button
                            mat-menu-item
                            *ngFor="let col of dynamicColumns"
                            (click)="showColumn(col)"
                          >
                            <mat-checkbox [checked]="col.visible">{{
                              col.name
                            }}</mat-checkbox>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      overflow-x: auto;
                      width: 100%;
                    "
                  >
                    <form [formGroup]="lineItemtableForm">
                      <ngx-datatable
                        #table
                        class="material expandable"
                        [rows]="dataSource"
                        [headerHeight]="50"
                        [footerHeight]="50"
                        [rowHeight]="'auto'"
                        [columnMode]="'force'"
                        [scrollbarH]="true"
                        [externalPaging]="false"
                        [externalSorting]="false"
                        [limit]="10"
                      >
                        <ngx-datatable-column name="S.No." [width]="100">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('position')
                              "
                              readonly
                              style="width: 40px"
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Part Number">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <ng-container *ngIf="isNew(rowIndex)">
                              <app-paginated-autocomplete-manual
                                [displayWithFunc]="
                                  filterFieldSupplierProductNameDisplayFn
                                "
                                [dataSrc]="boundGetSupplierProductAutoComplete"
                                [controlName]="'addedLineItempartNumber'"
                                [control]="getPartNumberControl(rowIndex)"
                                [placeholder]="'Select Part NUmber'"
                                [label]="'Part Number'"
                                (autoCompleteOptionSelected)="
                                  onPartNumberSelected($event, rowIndex)
                                "
                              >
                              </app-paginated-autocomplete-manual>
                            </ng-container>

                            <ng-container *ngIf="!isNew(rowIndex)">
                              <input
                                matInput
                                [formControl]="
                                  lineItemtableForm
                                    .get('rows')
                                    ['controls'][rowIndex].get('partNumber')
                                "
                                readonly
                                [matTooltip]="getDeclineReason(rowIndex)"
                                [matTooltipDisabled]="!isDecline(rowIndex)"
                              />
                            </ng-container>
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Supplier Part Number">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get(
                                    'supplierPartNumber'
                                  )
                              "
                              readonly
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Item Description">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <textarea
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('itemDescription')
                              "
                              [disabled]="true"
                              readonly
                              [ngClass]="{
                                'expanded-input': isWrapDescription
                              }"
                              [rows]="isWrapDescription ? 4 : 1"
                              matTooltipClass="mat-tooltip-custom"
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            ></textarea>
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Buyer Comment">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <textarea
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('buyerComment')
                              "
                              [disabled]="true"
                              readonly
                              [ngClass]="{
                                'expanded-input': isWrapDescription
                              }"
                              [rows]="isWrapDescription ? 4 : 1"
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            ></textarea>
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Supplier Comment">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <textarea
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('supplierComment')
                              "
                              [ngClass]="{
                                'expanded-input': isWrapDescription
                              }"
                              [rows]="isWrapDescription ? 4 : 1"
                              readonly
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            ></textarea>
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Customs Code">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('customsCode')
                              "
                              readonly
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Requested Quantity">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('quantity')
                              "
                              [disabled]="true"
                              readonly
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Quoted Quantity">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('supplierQuantity')
                              "
                              (blur)="calculateRowValues(rowIndex)"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              readonly
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Requested UOM">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('uom')
                              "
                              readonly
                              style="width: 100px"
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Quoted UOM">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              matInput
                              pattern="[A-Za-z\\s]*"
                              style="width: 100px"
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('supplierUom')
                              "
                              readonly
                              (keypress)="allowOnlyLetters($event)"
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column
                          name="Quoted Price"
                          [sortable]="true"
                          [width]="220"
                        >
                          <ng-template
                            ngx-datatable-header-template
                            let-column="column"
                          >
                            <div class="datatable-header-flex">
                              <span class="datatable-header-text">
                                Quoted Price
                                <span class="required-star">*</span>
                              </span>

                              <mat-slide-toggle
                                (change)="
                                  getColumn('requestedUnitCost')
                                    ? showToggleColumns(
                                        getColumn('requestedUnitCost')
                                      )
                                    : null
                                "
                                [checked]="
                                  getColumn('requestedUnitCost')?.visible
                                "
                                class="ml-2"
                              >
                              </mat-slide-toggle>

                              <button
                                mat-icon-button
                                style="padding: 0px"
                                [matTooltip]="
                                  'Currency conversion is powered by ExchangeRate-API and locked at entry.'
                                "
                              >
                                <mat-icon>info</mat-icon>
                              </button>

                              <!-- This renders the built-in sort icon -->
                              <span
                                class="datatable-sort-icon"
                                [class.active]="column.sort?.dir"
                              >
                                <i
                                  [ngClass]="{
                                    'fa fa-caret-up':
                                      column.sort?.dir === 'asc',
                                    'fa fa-caret-down':
                                      column.sort?.dir === 'desc'
                                  }"
                                ></i>
                              </span>
                            </div>
                          </ng-template>

                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              type="number"
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('unitCost')
                              "
                              (blur)="calculateRowValues(rowIndex)"
                              [disabled]="true"
                              step="any"
                              [readonly]="isDecline(rowIndex)"
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column
                          type="button"
                          *ngIf="getColumn('requestedUnitCost')?.visible"
                          name="Requested Unit Cost"
                        >
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            {{ headerData?.currencyId?.currencyCode }}
                            {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('requestedUnitCost').value | number: '1.2-2' }}
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Discount">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              type="number"
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('discount')
                              "
                              (blur)="calculateRowValues(rowIndex)"
                              step="any"
                              readonly
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column
                          name="Total Quoted Price"
                          [sortable]="true"
                          [width]="220"
                        >
                          <ng-template
                            ngx-datatable-header-template
                            let-column="column"
                          >
                            <div class="datatable-header-flex">
                              <span class="datatable-header-text"
                                >Total Quoted Price</span
                              >

                              <mat-slide-toggle
                                (change)="
                                  getColumn('requestedTotalCost')
                                    ? showToggleColumns(
                                        getColumn('requestedTotalCost')
                                      )
                                    : null
                                "
                                [checked]="
                                  getColumn('requestedTotalCost')?.visible
                                "
                                class="ml-2"
                              >
                              </mat-slide-toggle>

                              <button
                                mat-icon-button
                                style="padding: 0px"
                                [matTooltip]="
                                  'Currency conversion is powered by ExchangeRate-API and locked at entry.'
                                "
                              >
                                <mat-icon>info</mat-icon>
                              </button>

                              <!-- Sorting arrow (aligned to right) -->
                              <span
                                class="datatable-sort-icon"
                                [class.active]="column.sort?.dir"
                              >
                                <i
                                  [ngClass]="{
                                    'fa fa-caret-up':
                                      column.sort?.dir === 'asc',
                                    'fa fa-caret-down':
                                      column.sort?.dir === 'desc'
                                  }"
                                ></i>
                              </span>
                            </div>
                          </ng-template>

                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              type="number"
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('totalCost')
                              "
                              [disabled]="true"
                              step="any"
                              readonly
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column
                          type="button"
                          *ngIf="getColumn('requestedTotalCost')?.visible"
                          name="Requested Total Cost"
                        >
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            {{ headerData?.currencyId?.currencyCode }}
                            {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('requestedTotalCost').value | number: '1.2-2' }}
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Lead Time">
                          <ng-template
                            ngx-datatable-header-template
                            let-column="column"
                          >
                            Lead Time <span class="required-star">*</span>
                          </ng-template>
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <input
                              type="number"
                              matInput
                              [formControl]="
                                lineItemtableForm
                                  .get('rows')
                                  ['controls'][rowIndex].get('leadTime')
                              "
                              style="width: 100px"
                              readonly
                              [matTooltip]="getDeclineReason(rowIndex)"
                              [matTooltipDisabled]="!isDecline(rowIndex)"
                            />
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column
                          type="button"
                          *ngIf="getColumn('attachments')?.visible"
                          name="Attachments"
                        >
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <!-- <button
                              mat-icon-button
                              (click)="
                                toggleSidebar(true, 'attachment', rowIndex)
                              "
                              [disabled]="isDecline(rowIndex)"
                            >
                              <mat-icon>add_circle</mat-icon>
                            </button> -->

                            <button
                              mat-icon-button
                              (click)="
                                togglePreview(true, 'multiple', rowIndex)
                              "
                            >
                              <mat-icon>add_circle</mat-icon>
                            </button>
                          </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="" [width]="80">
                          <ng-template
                            let-rowIndex="rowIndex"
                            ngx-datatable-cell-template
                          >
                            <button
                              type="button"
                              *ngIf="!isDecline(rowIndex)"
                              mat-icon-button
                              class="delete-icon-button"
                              (click)="toggleSidebar(true, 'decline', rowIndex)"
                            >
                              <mat-icon>close</mat-icon>
                            </button>

                            <button
                              type="button"
                              *ngIf="isDecline(rowIndex)"
                              mat-icon-button
                              class="delete-icon-button"
                              (click)="restoreLineitem(rowIndex)"
                            >
                              <mat-icon>restore</mat-icon>
                            </button>
                          </ng-template>
                        </ngx-datatable-column>
                      </ngx-datatable>
                    </form>

                    <!-- <button
                      mat-raised-button
                      color="primary"
                      (click)="addNewLineItem()"
                      style="width: 10%"
                    >
                      Add New Row
                    </button> -->
                  </div>

                  <!-- <div
                    [ngClass]="{
                      secondformcontainerfull: !showDetailSection,
                      secondformcontainerhalf: showDetailSection
                    }"
                    style="margin: 30px; float: right"
                  >
                    <form [formGroup]="secondFormGroup">
                      <div class="floating-card-container">
                        <div class="floating-card">
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              align-items: center;
                              padding: 10px 20px;
                              font-weight: bold;
                            "
                          >
                            <span><b>Total</b></span>
                            <span>{{
                              secondFormGroup.get("quoteLineItemTotal")
                                ?.value || 0.0
                            }}</span>
                          </div>
                          <div class="card-body mx-4">
                            <div class="container">
                              <div class="row">
                                <hr />
                                <div class="col-xl-10">
                                  <p>Line Item list Price Sub Total</p>
                                </div>
                                <div class="col-xl-2">
                                  <p class="float-end">
                                    <input
                                      type="number"
                                      matInput
                                      [formControlName]="
                                        'quoteLineItemListPriceSubtotal'
                                      "
                                      [disabled]="true"
                                      step="any"
                                      readonly
                                    />
                                  </p>
                                </div>
                                <div class="col-xl-10">
                                  <p>Line Item Discount</p>
                                </div>
                                <div class="col-xl-2">
                                  <p class="float-end">
                                    <input
                                      type="number"
                                      matInput
                                      [formControlName]="
                                        'quoteLineItemDiscount'
                                      "
                                      [disabled]="true"
                                      step="any"
                                      readonly
                                    />
                                  </p>
                                </div>
                                <div class="col-xl-10">
                                  <p><b>Line Item Sub Total</b></p>
                                </div>
                                <div class="col-xl-2">
                                  <p class="float-end">
                                    <input
                                      type="number"
                                      matInput
                                      [formControlName]="
                                        'quoteLineItemSubtotal'
                                      "
                                      [disabled]="true"
                                      step="any"
                                      readonly
                                    />
                                  </p>
                                </div>
                                <hr />
                              </div>
                              <div class="row">
                                <div class="col-xl-10">
                                  <p><b>General Discount</b></p>
                                </div>
                                <div class="col-xl-2">
                                  <p class="float-end">
                                    <select
                                      formControlName="quoteLineItemGeneralDiscountType"
                                      style="width: 100%; margin-bottom: 10px"
                                      [disabled]="true"
                                    >
                                      <option value="percentage">
                                        Percentage
                                      </option>
                                      <option value="amount">value</option>
                                    </select>
                                    <input
                                      type="number"
                                      matInput
                                      [formControlName]="
                                        'quoteLineItemGeneralDiscountValue'
                                      "
                                      step="any"
                                      (blur)="calculateCostSummary()"
                                      readonly
                                    />
                                  </p>
                                </div>
                                <hr />
                              </div>
                              <div class="row">
                                <div class="col-xl-10">
                                  <p><b>Freight (In amount)</b></p>
                                </div>
                                <div class="col-xl-2">
                                  <p class="float-end">
                                    <button
                                      mat-icon-button
                                      matTooltipClass="mat-tooltip-custom"
                                      matTooltip="Add Additional Cost"
                                      matTooltipPosition="below"
                                      (click)="toggleSidebar(true, 'cost')"
                                    >
                                      <mat-icon>add_circle</mat-icon>
                                    </button>
                                  </p>
                                </div>
                                <div
                                  *ngIf="
                                    secondFormGroup.get('quoteLineItemFreight')
                                      ?.value
                                  "
                                  style="display: flex; flex-direction: column"
                                >
                                  <table class="table table-striped">
                                    <thead>
                                      <tr>
                                        <th>Freight Description</th>
                                        <th>Freight Type</th>
                                        <th>value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        *ngFor="
                                          let item of secondFormGroup.get(
                                            'quoteLineItemFreight'
                                          )?.value
                                        "
                                      >
                                        <td>{{ item.freightDescription }}</td>
                                        <td>{{ item.freightType }}</td>
                                        <td>{{ item.freightValue }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div
                                  style="
                                    display: flex;
                                    justify-content: flex-end;
                                    margin-bottom: 10px;
                                  "
                                >
                                  <input
                                    type="number"
                                    matInput
                                    [formControlName]="
                                      'quoteLineItemFreightTotal'
                                    "
                                    step="any"
                                    (blur)="calculateCostSummary()"
                                    readonly
                                  />
                                </div>
                                <hr style="border: 1px solid white" />
                              </div>
                              <div class="row text-black">
                                <div class="col-xl-12">
                                  <p
                                    class="float-end fw-bold"
                                    style="color: white !important"
                                  >
                                    Total:
                                    <input
                                      type="number"
                                      matInput
                                      [formControlName]="'quoteLineItemTotal'"
                                      [disabled]="true"
                                      step="any"
                                      readonly
                                    />
                                  </p>
                                </div>
                                <hr style="border: 1px solid white" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div> -->
                  <div style="margin: 30px 0px; float: none">
                    <form [formGroup]="secondFormGroup">
                      <div class="cost-summary-container">
                        <!-- First Table -->
                        <table class="summary-table">
                          <tbody>
                            <tr>
                              <td>Total ( {{ this.supplierCurrencyName }} )</td>
                              <td>
                                {{
                                  secondFormGroup.get("quoteLineItemTotal")
                                    ?.value || 0.0
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Line Item list Price Sub Total</td>
                              <td>
                                <input
                                  type="number"
                                  matInput
                                  formControlName="quoteLineItemListPriceSubtotal"
                                  readonly
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Line Item Discount</td>
                              <td>
                                <input
                                  type="number"
                                  matInput
                                  formControlName="quoteLineItemDiscount"
                                  readonly
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- Second Table -->
                        <table class="summary-table">
                          <tbody>
                            <tr>
                              <td>Line Item Sub Total</td>
                              <td>
                                <input
                                  type="number"
                                  matInput
                                  formControlName="quoteLineItemSubtotal"
                                  readonly
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>General Discount</td>
                              <td>
                                <!-- <select formControlName="quoteLineItemGeneralDiscountType" [disabled]="true">
                                    <option value="percentage">Percentage</option>
                                    <option value="amount">Value</option>
                                </select> -->
                                <input
                                  type="number"
                                  matInput
                                  formControlName="quoteLineItemGeneralDiscountValue"
                                  (blur)="calculateCostSummary()"
                                  readonly
                                />
                              </td>
                            </tr>
                            <!-- <tr>
                              <td (click)="toggleFreightDetails()">
                                Air Freight (In amount)<mat-icon>{{
                                  showFreightDetails
                                    ? "expand_less"
                                    : "expand_more"
                                }}</mat-icon>
                              </td>
                              <td>
                                <input
                                  type="number"
                                  matInput
                                  formControlName="quoteLineItemFreightTotal"
                                  (blur)="calculateCostSummary()"
                                  readonly
                                />
                              </td>
                            </tr> -->
                          </tbody>
                        </table>

                        <!-- Freight details table, visible only if showFreightDetails is true -->
                        <div
                          *ngIf="showFreightDetails && freightValues.length > 0"
                          style="display: flex; flex-direction: column"
                        >
                          <table class="summary-table">
                            <thead>
                              <tr>
                                <th style="padding: 10px">Description</th>
                                <!-- <th style="padding: 10px">Cost Type</th> -->
                                <th style="padding: 10px">Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                *ngFor="
                                  let item of secondFormGroup.get(
                                    'quoteLineItemFreight'
                                  )?.value
                                "
                              >
                                <td>{{ item.freightDescription }}</td>
                                <!-- <td>{{ item.freightType }}</td> -->
                                <td>{{ item.freightValue }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <!-- Third Table -->
                        <!-- <table
                          class="summary-table"
                          *ngIf="freightValues.length > 0"
                        >
                          <tbody>
                            <tr>
                              <td>Documentation Charges (In amount)</td>
                              <td>
                                <input
                                  type="number"
                                  matInput
                                  formControlName="quoteDocumentationCharges"
                                  readonly
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Packing Charges (In amount)</td>
                              <td>
                                <input
                                  type="number"
                                  matInput
                                  formControlName="quotePackingCharges"
                                  readonly
                                />
                              </td>
                            </tr>
                            <tr class="total-row">
                              <td><b>Total</b></td>
                              <td>
                                <input
                                  type="number"
                                  matInput
                                  [formControlName]="'quoteLineItemTotal'"
                                  [disabled]="true"
                                  step="any"
                                  readonly
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table> -->

                        <table class="summary-table">
                          <tbody>
                          <tr>
                              
                              <td>Applicable Tax Profile</td>
                              <td>
                              {{quoteLineItemApplicableTaxProfile}} %
                              </td>
                          </tr>
                          <tr>
                              <td>Tax Type</td>
                              <td>
                           
                                {{quoteLineItemTaxType}}
                              </td>
                          </tr>
                          <tr>
                            <td>Tax Amount</td>
                            <td>
                              {{quoteLineItemTaxAmount}}
                            </td>
                          </tr>
                          </tbody>
                      </table>

                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <!-- HEADER TAB -->
              <div class="quote-form-header-section">
                <!-- <h2 style="margin-bottom: 10px; font-weight: bolder">Quote Form - Header</h2> -->
                <div>
                  <form [formGroup]="firstFormGroup">
                    <div>
                      <div class="header-form">
                        <span
                          style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          "
                          (click)="toggleVisibility('form1')"
                        >
                          Quotation Details
                          <mat-icon>
                            {{ isForm1Expand ? "minimize" : "add" }}
                          </mat-icon>
                        </span>

                        <div *ngIf="isForm1Expand" class="three-column-flex">
                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Quote Ref Number</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="quoteRefNumber"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Quotation date</mat-label>
                              <input
                                matInput
                                name="quoteDate"
                                formControlName="quoteDate"
                                [matDatepicker]="quotedDateDatepicker"
                                [min]="minDate"
                                readonly
                              />

                              <mat-datepicker-toggle
                                matSuffix
                                [for]="quotedDateDatepicker"
                                [disabled]="true"
                              ></mat-datepicker-toggle>

                              <mat-datepicker
                                #quotedDateDatepicker
                              ></mat-datepicker>
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label
                                >Price Good Until<span
                                  class="required-star"
                                  style="color: red; margin-left: 2px"
                                  >*</span
                                ></mat-label
                              >
                              <input
                                matInput
                                name="priceGoodUntilDate"
                                formControlName="priceGoodUntilDate"
                                [matDatepicker]="priceGoodUntilDateDatepicker"
                                [min]="minDate"
                                readonly
                              />

                              <mat-datepicker-toggle
                                matSuffix
                                [for]="priceGoodUntilDateDatepicker"
                                [disabled]="true"
                              ></mat-datepicker-toggle>

                              <mat-datepicker
                                #priceGoodUntilDateDatepicker
                              ></mat-datepicker>
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label
                                >Offered quality<span
                                  class="required-star"
                                  style="color: red; margin-left: 2px"
                                  >*</span
                                ></mat-label
                              >
                              <mat-select
                                formControlName="offeredQuality"
                                [disabled]="true"
                                class="readonly-select"
                              >
                                <mat-option
                                  *ngFor="let item of offeredQualityData"
                                  [value]="item.id"
                                >
                                  {{ item.qualityDescription }}</mat-option
                                >
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label
                                >For on-time-delivery order by<span
                                  class="required-star"
                                  style="color: red; margin-left: 2px"
                                  >*</span
                                ></mat-label
                              >
                              <input
                                matInput
                                name="onTimeDeliveryOrderDate"
                                formControlName="onTimeDeliveryOrderDate"
                                [matDatepicker]="
                                  onTimeDeliveryOrderDateDateDatepicker
                                "
                                [min]="minDate"
                                readonly
                              />

                              <mat-datepicker-toggle
                                matSuffix
                                [for]="onTimeDeliveryOrderDateDateDatepicker"
                                [disabled]="true"
                              ></mat-datepicker-toggle>

                              <mat-datepicker
                                #onTimeDeliveryOrderDateDateDatepicker
                              ></mat-datepicker>
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Quoted Delivery In Days</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="quotedDeliveryInDays"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                readonly
                              />
                            </mat-form-field>
                          </div>
                        </div>
                      </div>

                      <div class="header-form">
                        <span
                          style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          "
                          (click)="toggleVisibility('form2')"
                        >
                          Incoterms Details
                          <mat-icon>
                            {{ isForm2Expand ? "minimize" : "add" }}
                          </mat-icon>
                        </span>

                        <div *ngIf="isForm2Expand" class="three-column-flex">
                          <div class="header-form-item-row">
                            <mat-form-field
                              appearance="fill"
                              class="full-width"
                            >
                              <mat-label>Incoterm</mat-label>

                              <mat-select
                                formControlName="incoterms"
                                (selectionChange)="
                                  onIncotermSelected($event.value)
                                "
                                [disabled]="true"
                                class="readonly-select"
                              >
                                <mat-option
                                  *ngFor="let item of incoterms"
                                  [value]="item.id"
                                >
                                  {{ item.incotermCode }}</mat-option
                                >
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="header-form-item-row">
                            <mat-form-field
                              appearance="fill"
                              class="full-width"
                            >
                              <mat-label>Incoterm Locations</mat-label>

                              <input
                                matInput
                                [formControl]="countryControl"
                                [matAutocomplete]="auto"
                                (ngModelChange)="onInputChange($event)"
                                placeholder="Select Countries"
                                readonly
                              />

                              <mat-autocomplete
                                #auto="matAutocomplete"
                                autoActiveFirstOption="false"
                                panelClass="custom-autocomplete-panel"
                              >
                                <mat-option
                                  *ngFor="let country of filteredCountries"
                                  [value]="null"
                                  class="no-selection"
                                >
                                  <mat-checkbox
                                    [checked]="isCountrySelected(country)"
                                    (change)="onCheckboxChange($event, country)"
                                    class="yellow-checkbox"
                                  >
                                    {{ country.name }}
                                  </mat-checkbox>
                                </mat-option>
                              </mat-autocomplete>

                              <mat-hint
                                *ngIf="selectedCountries.length"
                                style="font-weight: bold; margin-top: 8px"
                              >
                                {{ getSelectedCountries() }}
                              </mat-hint>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>

                      <div class="header-form">
                        <span
                          style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          "
                          (click)="toggleVisibility('form3')"
                        >
                          My Details
                          <mat-icon>
                            {{ isForm3Expand ? "minimize" : "add" }}
                          </mat-icon>
                        </span>

                        <div *ngIf="isForm3Expand" class="three-column-flex">
                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Contact Name</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="supplierContactName"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Email Address</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="supplierEmail"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Telephone Number</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="supplierTelephone"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Mobile Number</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="supplierMobile"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Company Email</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="supplierCompanyEmail"
                                readonly
                              />
                            </mat-form-field>
                          </div>
                        </div>
                      </div>

                      <div class="header-form">
                        <span
                          style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          "
                          (click)="toggleVisibility('form4')"
                        >
                          Buyer Comment & Attachments
                          <mat-icon>
                            {{ isForm4Expand ? "minimize" : "add" }}
                          </mat-icon>
                        </span>

                        <div
                          *ngIf="isForm4Expand"
                          style="
                            margin-top: 32px;
                            display: flex;
                            gap: 10px;
                            justify-content: flex-start;
                            align-items: center;
                          "
                        >
                          <div style="display: flex; width: 100%">
                            <div class="buyer-comment" style="flex: 1">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Buyer Comment</mat-label>
                                <textarea
                                  matInput
                                  placeholder=""
                                  formControlName="buyerComment"
                                  readonly
                                ></textarea>
                              </mat-form-field>
                            </div>

                            <div
                              style="
                                display: flex;
                                align-items: center;
                                flex: 1;
                              "
                              class="file-name-box"
                            >
                              <span>
                                {{
                                  buyerAttachmentUrl.length === 0
                                    ? "No files attached"
                                    : buyerAttachmentUrl.length === 1
                                    ? "1 file attached"
                                    : buyerAttachmentUrl.length +
                                      " files attached"
                                }}
                              </span>

                              <button
                                mat-icon-button
                                *ngIf="buyerAttachmentUrl.length > 0"
                                (click)="toggleBuyerAttachments(true)"
                                type="button"
                              >
                                <mat-icon>visibility</mat-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="header-form">
                        <span
                          style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          "
                          (click)="toggleVisibility('form5')"
                        >
                          Supplier Comment & Attachments
                          <mat-icon>
                            {{ isForm5Expand ? "minimize" : "add" }}
                          </mat-icon>
                        </span>

                        <div
                          *ngIf="isForm5Expand"
                          style="
                            margin-top: 32px;
                            display: flex;
                            gap: 10px;
                            justify-content: flex-start;
                            align-items: center;
                          "
                        >
                          <div style="display: flex; width: 100%">
                            <div class="buyer-comment" style="flex: 1">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Supplier Comment</mat-label>
                                <textarea
                                  matInput
                                  placeholder=""
                                  formControlName="supplierComment"
                                  readonly
                                ></textarea>
                              </mat-form-field>
                            </div>

                            <div
                              style="
                                display: flex;
                                align-items: center;
                                flex: 1;
                              "
                              class="file-name-box"
                            >
                              <span>
                                {{
                                  !firstFormGroup.get('quoteHeaderAttachments')?.value ||
                                  firstFormGroup.get('quoteHeaderAttachments')?.value?.length === 0
                                    ? "No files attached"
                                    : firstFormGroup.get('quoteHeaderAttachments')?.value?.length === 1
                                    ? "1 file attached"
                                    : firstFormGroup.get('quoteHeaderAttachments')?.value?.length +
                                      " files attached"
                                }}
                              </span>

                              <button
                                mat-icon-button
                                *ngIf="firstFormGroup.get('quoteHeaderAttachments')?.value?.length > 0"
                                (click)="toggleSupplierAttachments(true)"
                                type="button"
                              >
                                <mat-icon>visibility</mat-icon>
                              </button>
                            </div>
                          </div>

                          <!-- <div class="header-form-item-row">
                            <div class="full-width" style="margin-bottom: 30px">
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  margin-bottom: 10px;
                                "
                              >
                                <label style="font-size: 17px; margin: 0"
                                  >Supplier Terms and Conditions</label
                                >
                                <button
                                  *ngIf="
                                    paymentTermsAndConditionAttachmentUrl?.trim()
                                  "
                                  mat-icon-button
                                  matTooltip="Preview Attachments"
                                  matTooltipPosition="below"
                                  (click)="
                                    togglePaymentTermsAndConditionsAttachment(
                                      true
                                    )
                                  "
                                  style="margin-left: 8px"
                                >
                                  <mat-icon>visibility</mat-icon>
                                </button>
                              </div>
                              <div
                                style="
                                  max-height: 180px;
                                  overflow-y: auto;
                                  border-bottom: 1px solid rgba(0, 0, 0, 0.45);
                                  font-size: 15px;
                                  background-color: whitesmoke;
                                  border-radius: 4px;
                                  padding: 20px;
                                "
                              >
                                <div
                                  class="terms-container"
                                  [innerHTML]="paymentTermsAndConditions"
                                  style="
                                    white-space: pre-wrap;
                                    word-wrap: break-word;
                                  "
                                ></div>
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>

                      <div class="header-form">
                        <span
                          style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          "
                          (click)="toggleVisibility('form6')"
                        >
                          Freight Forwarder Details
                          <mat-icon>
                            {{ isForm6Expand ? "minimize" : "add" }}
                          </mat-icon>
                        </span>

                        <div *ngIf="isForm6Expand" class="three-column-flex">
                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label
                                >Freight Forwarder Company Name</mat-label
                              >
                              <input
                                matInput
                                placeholder=""
                                formControlName="freightForwarderCompanyName"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>PIC</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="pic"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Job Title</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="freightForwarderJobTitle"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Email Id</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="freightForwarderEmailId"
                                maxlength="255"
                                pattern="^([a-zA-Z0-9_\-\.\+]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,})$"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Phone</mat-label>
                              <input
                                matInput
                                name="freightForwarderPhone"
                                formControlName="freightForwarderPhone"
                                placeholder="Phone"
                                maxlength="25"
                                onkeypress="return event.charCode >= 32 && event.charCode <= 64 ||  event.charCode >= 91 && event.charCode <= 96 ||  event.charCode >= 123 && event.charCode <= 126"
                                readonly
                              />
                            </mat-form-field>
                          </div>
                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Fax</mat-label>
                              <input
                                matInput
                                name="freightForwarderFax"
                                formControlName="freightForwarderFax"
                                placeholder="Fax"
                                maxlength="25"
                                onkeypress="return event.charCode >= 32 && event.charCode <= 64 ||  event.charCode >= 91 && event.charCode <= 96 ||  event.charCode >= 123 && event.charCode <= 126"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Address</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="freightForwarderAddress"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Packaging</mat-label>
                              <input
                                matInput
                                placeholder=""
                                formControlName="packaging"
                                readonly
                              />
                            </mat-form-field>
                          </div>

                          <div class="header-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Mode of Transport</mat-label>
                              <mat-select
                                formControlName="modeOfTransport"
                                [disabled]="true"
                              >
                                <mat-option value="maritime">
                                  Maritime</mat-option
                                >
                                <mat-option value="rail"> Rail</mat-option>
                                <mat-option value="road"> Road</mat-option>
                                <mat-option value="air"> Air</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <!-- PAYMENT TERMS TAB -->
              <div class="quote-form-payment-terms-section">
                <!-- <h2 style="margin-bottom: 10px; font-weight: bolder">Quote Form - Payment Terms</h2> -->
                <div>
                  <form [formGroup]="paymentFormGroup">
                    <div style="display: flex; flex-direction: column">
                      <div class="payment-terms-header-form">
                        <span
                          style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          "
                          (click)="toggleVisibility('form3')"
                        >
                          My Payment Terms
                        </span>

                        <div>
                          <div class="payment-terms-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label
                                >Payment Terms<span
                                  class="required-star"
                                  style="color: red; margin-left: 2px"
                                  >*</span
                                ></mat-label
                              >
                              <mat-select
                                readonly 
                                [disabled]="true"
                                formControlName="paymentTermsId"
                                [value]="paymentTermsId"
                                placeholder=""
                              >
                                <mat-option
                                  *ngFor="let item of paymentTermsData"
                                  [value]="item.id"
                                  >{{ item.name }}</mat-option
                                >
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div class="payment-terms-form-item-row">
                            <div class="full-width" style="margin-bottom: 30px">
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  margin-bottom: 10px;
                                "
                              >
                                <label style="font-size: 17px; margin: 0"
                                  >Terms and Conditions</label
                                >
                                <button
                                  *ngIf="
                                    paymentTermsAndConditionAttachmentUrl?.trim()
                                  "
                                  mat-icon-button
                                  matTooltip="Preview Attachments"
                                  matTooltipPosition="below"
                                  (click)="
                                    togglePaymentTermsAndConditionsAttachment(
                                      true
                                    )
                                  "
                                  style="margin-left: 8px"
                                >
                                  <mat-icon>visibility</mat-icon>
                                </button>
                              </div>
                              <div
                                style="
                                  max-height: 180px;
                                  overflow-y: auto;
                                  border-bottom: 1px solid rgba(0, 0, 0, 0.45);
                                  font-size: 15px;
                                  background-color: whitesmoke;
                                  border-radius: 4px;
                                  padding: 20px;
                                "
                              >
                                <div
                                  class="terms-container"
                                  [innerHTML]="paymenttermsconditioncolumn"
                                  style="
                                    white-space: pre-wrap;
                                    word-wrap: break-word;
                                  "
                                ></div>
                              </div>
                            </div>
                          </div>

                          <div class="payment-terms-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label
                                >Currency Instructions<span
                                  class="required-star"
                                  style="color: red; margin-left: 2px"
                                  >*</span
                                ></mat-label
                              >

                              <textarea
                                matInput
                                placeholder=""
                                formControlName="currencyInstructions"
                              ></textarea>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>

                      <div class="payment-terms-header-form">
                        <span
                          style="
                            padding-left: 16px;
                            padding-top: 16px;
                            padding-bottom: 18px;
                            margin-bottom: 12px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                          "
                          (click)="toggleVisibility('form5')"
                        >
                          Buyer Payment Terms
                        </span>

                        <div>
                          <div
                            class="payment-terms-form-item-row"
                            style="margin-bottom: 10px"
                          >
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Billing Address</mat-label>

                              <textarea
                                matInput
                                placeholder="Billing Address"
                                formControlName="billingAddress"
                                readonly
                              >
                              </textarea>
                            </mat-form-field>
                          </div>

                          <div
                            class="payment-terms-form-item-row"
                            style="margin-bottom: 10px"
                          >
                            <div class="full-width">
                              <!-- <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  margin-bottom: 10px;
                                "
                              >
                                <label style="font-size: 17px; margin: 0"
                                  >Tax Status</label
                                >
                              </div>
                              <div
                                *ngIf="
                                  this.buyerFormGroup.get('taxStatus')?.value
                                    ?.length
                                "
                                class="table-container"
                              >
                                <table class="mat-elevation-z2">
                                  <thead>
                                    <tr>
                                      <th style="width: 50%">Applicable TAX</th>
                                      <th style="width: 50%">Tax Percentage</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      *ngFor="
                                        let tax of this.buyerFormGroup.get(
                                          'taxStatus'
                                        )?.value;
                                        let i = index
                                      "
                                    >
                                      <td>{{ tax.name }}</td>
                                      <td>{{ tax.percentage }}%</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div> -->

                              <div class="readonly-wrapper">
                                <mat-form-field
                                  class="full-width"
                                  color="accent"
                                >
                                  <mat-label>Applicable Tax Profile</mat-label>

                                  <mat-select
                                    formControlName="taxStatus"
                                    placeholder=""
                                  >
                                    <mat-option
                                      *ngFor="let item of taxStatusData"
                                      [value]="item.taxId"
                                    >
                                      {{ item.country?.name }} -
                                      {{ item.taxType }} ({{ item.regionName }})
                                      - {{ item.taxNumber }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <div class="readonly-overlay"></div>
                              </div>
                            </div>
                          </div>

                          <div
                            class="payment-terms-form-item-row"
                            style="margin-bottom: 30px; margin-top: 30px"
                          >
                            <div class="full-width" style="margin-bottom: 10px">
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  margin-bottom: 10px;
                                "
                              >
                                <label style="font-size: 17px; margin: 0"
                                  >Terms and Conditions</label
                                >
                                <button
                                  *ngIf="
                                    buyerPaymentTermsAndConditionAttachmentUrl?.trim()
                                  "
                                  mat-icon-button
                                  matTooltip="Preview Attachments"
                                  matTooltipPosition="below"
                                  (click)="
                                    toggleBuyerPaymentTermsAndConditionsAttachment(
                                      true
                                    )
                                  "
                                  style="margin-left: 8px"
                                >
                                  <mat-icon>visibility</mat-icon>
                                </button>
                              </div>
                              <div
                                style="
                                  max-height: 140px;
                                  overflow-y: auto;
                                  border-bottom: 1px solid rgba(0, 0, 0, 0.45);
                                  font-size: 15px;
                                  background-color: whitesmoke;
                                  border-radius: 4px;
                                  padding: 20px;
                                "
                              >
                                <div
                                  class="terms-container"
                                  [innerHTML]="
                                    paymentFormGroup.get(
                                      'buyerTermsAndConditions'
                                    )?.value
                                  "
                                  style="
                                    white-space: pre-wrap;
                                    word-wrap: break-word;
                                  "
                                ></div>
                              </div>
                            </div>
                          </div>

                          <div class="payment-terms-form-item-row">
                            <mat-form-field class="full-width" color="accent">
                              <mat-label>Payment Terms</mat-label>

                              <textarea
                                matInput
                                placeholder="Payment Terms"
                                formControlName="buyerPaymentTerms"
                                readonly
                              ></textarea>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  padding: 0px 15px;
                  margin-top: 30px;
                "
              >
                <div *ngIf="this.quoteStatus !== 14">
                  <button
                    mat-button
                    color="primary"
                    style="
                      margin: 0px 10px;
                      font-size: 18px;
                      padding-left: 30px;
                      padding-right: 25px;
                      padding-top: 24px;
                      padding-bottom: 24px;
                      background-color: #f99c30 !important;
                    "
                    (click)="submit(true)"
                  >
                    Save as Draft
                  </button>
                </div>
                <div *ngIf="this.quoteStatus !== 3">
                  <button
                    mat-button
                    color="primary"
                    style="
                      margin: 0px 10px;
                      font-size: 18px;
                      padding-left: 25px;
                      padding-right: 25px;
                      padding-top: 24px;
                      padding-bottom: 24px;
                      background-color: #f99c30 !important;
                    "
                    (click)="submit(false)"
                  >
                    Submit
                  </button>
                </div>

                <!-- <button mat-button color="primary"
                        style="margin:0px 10px;font-size:18px; padding-left: 25px; padding-right: 25px; padding-top: 24px; padding-bottom: 24px; background-color: #f99c30 !important;"
                        (click)="back()">Back</button> -->
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<!-- Popup for confirmation -->
<div class="namemodal" *ngIf="showConfirmationDialogue">
  <div class="modalContent">
    <div class="p-6 text-center">
      <div class="flex justify-center mb-4">
        <div
          class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
        >
          <mat-icon
            class="text-orange-600"
            style="font-size: 40px; height: 100%; width: 100%"
            >warning</mat-icon
          >
        </div>
      </div>
      <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
      <p class="mb-6">
        Are you sure you want to submit this quotation?<br />Once submitted,
        changes cannot be made.
      </p>
      <div class="flex justify-center gap-4">
        <button
          mat-raised-button
          color="primary"
          (click)="save(false)"
          style="margin-right: 5px"
        >
          OK
        </button>
        <button mat-stroked-button (click)="cancel()" style="margin-left: 5px">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup for confirmation -->
<div class="namemodal" *ngIf="showCloseDialogue">
  <div class="modalContent">
    <div class="p-6 text-center">
      <div class="flex justify-center mb-4">
        <div
          class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
        >
          <mat-icon
            class="text-orange-600"
            style="font-size: 40px; height: 100%; width: 100%"
            >warning</mat-icon
          >
        </div>
      </div>
      <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
      <p class="mb-6">Are you sure you want to save this quotation as draft?</p>
      <div class="flex justify-center gap-4">
        <button
          mat-raised-button
          color="primary"
          (click)="save(true)"
          style="margin-right: 5px"
        >
          Save as draft
        </button>
        <button mat-stroked-button (click)="cancel()" style="margin-left: 5px">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="blur"
  *ngIf="paymentTermsAndConditionsSection"
  (click)="togglePaymentTermsAndConditionsAttachment(false)"
></div>
<div class="carousel-container" *ngIf="paymentTermsAndConditionsSection">
  <div class="carousel-close-button">
    <button
      class="image-close-button"
      (click)="togglePaymentTermsAndConditionsAttachment(false)"
    >
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <!-- <button class="carousel-control prev" (click)="prevSlide()">
        &#10094;
    </button> -->

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(paymentTermsAndConditionAttachmentUrl)"
      >
        <pdf-viewer
          [src]="paymentTermsAndConditionAttachmentUrl"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(paymentTermsAndConditionAttachmentUrl)"
      >
        <img
          [src]="paymentTermsAndConditionAttachmentUrl"
          [alt]="'headerattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <!-- <button class="carousel-control next" (click)="nextSlide()">
        &#10095;
    </button> -->
  </div>
</div>

<div
  class="blur"
  *ngIf="buyerPaymentTermsAndConditionsSection"
  (click)="toggleBuyerPaymentTermsAndConditionsAttachment(false)"
></div>
<div class="carousel-container" *ngIf="buyerPaymentTermsAndConditionsSection">
  <div class="carousel-close-button">
    <button
      class="image-close-button"
      (click)="toggleBuyerPaymentTermsAndConditionsAttachment(false)"
    >
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <!-- <button class="carousel-control prev" (click)="prevSlide()">
        &#10094;
    </button> -->

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(paymentTermsAndConditionAttachmentUrl)"
      >
        <pdf-viewer
          [src]="buyerPaymentTermsAndConditionAttachmentUrl"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(buyerPaymentTermsAndConditionAttachmentUrl)"
      >
        <img
          [src]="buyerPaymentTermsAndConditionAttachmentUrl"
          [alt]="'headerattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <!-- <button class="carousel-control next" (click)="nextSlide()">
        &#10095;
    </button> -->
  </div>
</div>

<div
  class="blur"
  *ngIf="headerAttachmentSection"
  (click)="toggleHeaderAttachmentImage(false)"
></div>
<div class="carousel-container" *ngIf="headerAttachmentSection">
  <div class="carousel-close-button">
    <button
      class="image-close-button"
      (click)="toggleHeaderAttachmentImage(false)"
    >
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <!-- <button class="carousel-control prev" (click)="prevSlide()">
        &#10094;
    </button> -->

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(headerAttachmentUrl)"
      >
        <pdf-viewer
          [src]="headerAttachmentUrl"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(headerAttachmentUrl)"
      >
        <img
          [src]="headerAttachmentUrl"
          [alt]="'headerattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <!-- <button class="carousel-control next" (click)="nextSlide()">
        &#10095;
    </button> -->
  </div>
</div>

<div
  class="blur"
  *ngIf="paymentTermsAndConditionsSection"
  (click)="togglePaymentTermsAndConditionsAttachment(false)"
></div>
<div class="carousel-container" *ngIf="paymentTermsAndConditionsSection">
  <div class="carousel-close-button">
    <button
      class="image-close-button"
      (click)="togglePaymentTermsAndConditionsAttachment(false)"
    >
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <!-- <button class="carousel-control prev" (click)="prevSlide()">
        &#10094;
    </button> -->

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(paymentTermsAndConditionAttachmentUrl)"
      >
        <pdf-viewer
          [src]="paymentTermsAndConditionAttachmentUrl"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(paymentTermsAndConditionAttachmentUrl)"
      >
        <img
          [src]="paymentTermsAndConditionAttachmentUrl"
          [alt]="'headerattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <!-- <button class="carousel-control next" (click)="nextSlide()">
        &#10095;
    </button> -->
  </div>
</div>

<div
  class="blur"
  *ngIf="supplierAttachmentsSection"
  (click)="toggleSupplierAttachments(false)"
></div>
<div class="carousel-container" *ngIf="supplierAttachmentsSection">
  <div
    class="carousel-close-button"
    style="display: flex; flex-direction: row; gap: 10px"
  >
    <button
      class="image-download-button"
      *ngIf="supplierAttachmentUrls.length > 0"
      (click)="downloadDocument(supplierAttachmentUrls[supplierCurrentIndex])"
    >
      <mat-icon style="font-size: 20px">download</mat-icon>
    </button>

    <button class="image-close-button" (click)="toggleSupplierAttachments(false)">
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <button class="carousel-control prev" (click)="prevSupplierSlide()">
      &#10094;
    </button>

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(supplierAttachmentUrls[supplierCurrentIndex])"
      >
        <pdf-viewer
          [src]="supplierAttachmentUrls[supplierCurrentIndex]"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(supplierAttachmentUrls[supplierCurrentIndex])"
      >
        <img
          [src]="supplierAttachmentUrls[supplierCurrentIndex]"
          [alt]="'supplier attachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <button class="carousel-control next" (click)="nextSupplierSlide()">
      &#10095;
    </button>
  </div>
</div>

<div
  class="blur"
  *ngIf="buyerAttachmentsSection"
  (click)="toggleBuyerAttachments(false)"
></div>
<div class="carousel-container" *ngIf="buyerAttachmentsSection">
  <div
    class="carousel-close-button"
    style="display: flex; flex-direction: row; gap: 10px"
  >
    <button
      class="image-download-button"
      *ngIf="buyerAttachmentUrl.length > 0"
      (click)="downloadDocument(buyerAttachmentUrl[currentIndex])"
    >
      <mat-icon style="font-size: 20px">download</mat-icon>
    </button>

    <button class="image-close-button" (click)="toggleBuyerAttachments(false)">
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
    </button>

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(buyerAttachmentUrl[currentIndex])"
      >
        <pdf-viewer
          [src]="buyerAttachmentUrl[currentIndex]"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(buyerAttachmentUrl[currentIndex])"
      >
        <img
          [src]="buyerAttachmentUrl[currentIndex]"
          [alt]="'headerattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
    </button>
  </div>
</div>

<!-- Notification Overlay to Dim the Background -->
<div *ngIf="showNotification" class="notification-overlay"></div>

<!-- Custom Notification for Missing Fields -->
<div
  *ngIf="showNotification"
  class="notification-popup"
  [ngClass]="{
    'error-notification': notificationType === 'error',
    'info-notification': notificationType === 'info',
    show: showNotification,
    hide: !showNotification
  }"
>
  <div class="notification-content">
    <div class="flex justify-center mb-4">
      <div
        class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
      >
        <mat-icon
          class="text-orange-600"
          style="font-size: 75px; height: 100%; width: 100%"
          >warning</mat-icon
        >
      </div>
    </div>
    <div class="notification-message" [innerHTML]="notificationMessage"></div>
    <button (click)="dismissNotification()" class="btn-ok">OK</button>
  </div>
</div>

<div class="carousel-container" *ngIf="previewSection">
  <div
    class="carousel-close-button"
    style="display: flex; flex-direction: row; gap: 10px"
  >
    <!-- <button class="image-download-button" *ngIf="buyerAttachmentUrl.length>0"   (click)="downloadDocument(buyerAttachmentUrl[currentIndex])">
          <mat-icon style="font-size:20px">download</mat-icon>
  </button> -->

    <button class="image-close-button" (click)="togglePreview(false, '')">
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <button class="carousel-control prev" (click)="prevDocSlide()">
      &#10094;
    </button>

    <div class="carousel-image-container">
      <ng-container *ngIf="previewDocs.length == 0">
        <div class="alert alert-danger">No Attachments.</div>
      </ng-container>

      <ng-container *ngIf="previewDocs.length > 0">
        <div
          class="headerattachmentcarouselimageContainerInner"
          *ngIf="isPdf(previewDocs[currentDocIndex]?.url)"
        >
          <pdf-viewer
            [src]="previewDocs[currentDocIndex]?.url"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="content"
          >
          </pdf-viewer>
        </div>
        <div
          class="headerattachmentimage-container-inner"
          *ngIf="!isPdf(previewDocs[currentDocIndex]?.url)"
        >
          <img
            [src]="previewDocs[currentDocIndex]?.url"
            [alt]="'headerattachment image'"
            class="carousel-image"
          />
        </div>
      </ng-container>
    </div>

    <button class="carousel-control next" (click)="nextDocSlide()">
      &#10095;
    </button>
  </div>
</div>
